function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 1"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Close icon",
  d: "M12.5 0A12.5 12.5 0 1025 12.5 12.5 12.5 0 0012.5 0zm6.25 17L17 18.75l-4.5-4.49L8 18.75 6.25 17l4.49-4.49L6.25 8 8 6.25l4.49 4.49L17 6.25 18.75 8l-4.49 4.5z"
})));

function SvgCloseicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNSAyNSI+PGcgaWQ9IldhcnN0d2FfMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDIiPjxnIGlkPSJXYXJzdHdhXzEtMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDEiPjxwYXRoIGlkPSJDbG9zZV9pY29uIiBkYXRhLW5hbWU9IkNsb3NlIGljb24iIGQ9Ik0xMi41LDBBMTIuNSwxMi41LDAsMSwwLDI1LDEyLjUsMTIuNSwxMi41LDAsMCwwLDEyLjUsMFptNi4yNSwxN0wxNywxOC43NSwxMi41LDE0LjI2LDgsMTguNzUsNi4yNSwxN2w0LjQ5LTQuNDlMNi4yNSw4LDgsNi4yNWw0LjQ5LDQuNDlMMTcsNi4yNSwxOC43NSw4LDE0LjI2LDEyLjVaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgCloseicon as ReactComponent };